import { Flex } from '@chakra-ui/react';
import * as React from 'react';

export function LoadingPage() {
    return(
        <Flex w='full' h='full'>
            
        </Flex>
    )
}